import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser, selectUser } from '../../redux/slices/authSlice';

const PersonalInfo = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  return (
    <div style={{ padding: 24 }}>
      <h2>Personal Info</h2>
      <p>
        Signed in as: {user?.email} ({user?.role})
      </p>
      <button type="button" onClick={() => dispatch(logoutUser())}>
        Sign out
      </button>
    </div>
  );
};

export default PersonalInfo;
